import {
    disableButtonContinueAction,
    setValuesAction,
    hideLicenceNotFoundAction,
} from '../../_flux/actions/rego_lookup_actions';
import {Filters} from '../../_flux/constants/filter/filters';
import {getDefaultValueForFilter} from '../../_flux/helper/filters/get_default_value_for_filter';
import {isNzStore} from '../configurator/common';

export function onRetry() {
    const values = {};
    values[Filters.VEHICLE_STATE] = getDefaultValueForFilter(Filters.VEHICLE_STATE);
    if(isNzStore(TYROOLA.globals.store)) {
        values[Filters.VEHICLE_STATE] = 'NZ';
    }

    values[Filters.REGISTRATION] = getDefaultValueForFilter(Filters.REGISTRATION);
    values[Filters.VEHICLE_MAKE] = '';
    values[Filters.VEHICLE_MODEL] = '';
    values[Filters.VEHICLE_DETAILS] = '';
    setValuesAction(values);
    disableButtonContinueAction();
    hideLicenceNotFoundAction();
}
